import React, { useState, useEffect } from "react";
function UserDropdown(props) {
  const [userdata, setUserdata] = useState({});
  useEffect(() => {
    if (localStorage.getItem("userdata")) {
      setUserdata(JSON.parse(localStorage.getItem("userdata")));
    } else {
      // Redirect to login page
      window.location.href = "/";
    }
  }, []);

  return (
    <li className="flex items-center gap-3">
      <span className="text-sm text-gray-700 truncate max-w-[40vw] sm:max-w-none">
        Welcome,&nbsp;<b>{userdata.name}</b>
      </span>
      <a
        href="/logout"
        className="inline-flex items-center gap-2 bg-gray-800 hover:bg-gray-700 text-white text-sm font-bold px-4 py-2 rounded shadow active:bg-gray-600 transition-all duration-150"
      >
        <i className="fas fa-sign-out-alt" />
        <span>Logout</span>
      </a>
    </li>
  );
}
export default UserDropdown;
